<template>
  <div class="live-item" :style="`background-image: url(${item.advanceListImg})`">
    <div class="item-content">
      <img v-if="item.advanceVideo" class="play-img" src="../../assets/images/play.png" alt="壹心理直播-列表">
      <div class="preview-box">
        <notice-tag :title="title" :content="content"></notice-tag>

        <img
          class="icon-nav"
          v-if="item.showType"
          :src="item.showType === 1 ?
            require('../../assets/images/icon-video.png') :
            require('../../assets/images/icon-broadcast.png')
          "
          alt="壹心理直播"
        />
      </div>
      <div class="bottom-con">
        <info-con :img-src="item.channelAvatar" :title="item.channelName" :subheading="item.advanceTitle"></info-con>
      </div>
    </div>
  </div>
</template>

<script>
  import { timeSplit } from '@/utils/utils'
  import NoticeTag from 'components/NoticeTag'
  import InfoCon from 'components/InfoCon'

  export default {
    name: "Live",
    components: {
      NoticeTag,
      InfoCon
    },
    props: {
      item: {
        type: Object,
        default: ()=>{}
      }
    },
    data() {
      return {
        title: '预告'
      }
    },
    computed: {
      liveTime() {
        const res = timeSplit(this.item.liveTime)
        return res
      },
      content() {
        return `${this.liveTime.month}月${this.liveTime.day}日 ${this.liveTime.hour}:${this.liveTime.min}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";

  .live-item {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .preview-box {
    position: absolute;
    top: 16px;
    left: 16px;
    right: 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon-nav {
      display: block;
      width: 26px;
      height: 26px;
    }
  }

  .bottom-con {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .play-img {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -30px;
    margin-top: -30px;
    width: 60px;
    height: 60px;
  }
</style>
